module.exports = __webpack_public_path__ + "static/media/ios-step1.09c567b9.png";